export const HMkRepeatedValues = {
  medicalCondition: '',
  therapeuticIntervention: '',
  treatmentPlan: '',
};
